import { observer } from 'mobx-react-lite'
import { SymbolConnectorAction } from '@/features/legends/symbols/components/SymbolConnector'
import { SymbolConnectorContainer } from '@/features/legends/symbols/components/SymbolConnector/SymbolConnectorContainer'
import { SymbolConnectorList } from '@/features/legends/symbols/components/SymbolConnectorList'
import type { SymbolConnectorListViewModel } from '@/features/legends/symbols/SymbolConnectorListViewModel'

export interface SymbolConnectorListContainerProps {
  vm: SymbolConnectorListViewModel
  isDisabled?: boolean
  placeholder?: string
  testId?: string
}

export const SymbolConnectorListContainer = observer(
  function SymbolConnectorListContainer({
    vm,
    isDisabled: isDisabledProp,
    placeholder,
    testId,
  }: SymbolConnectorListContainerProps) {
    const isDisabled = vm.isEditingDisabled || isDisabledProp
    return (
      <SymbolConnectorList
        isEmpty={vm.count === 0}
        onAdd={vm.add}
        isDisabled={isDisabled}
        testId={testId}
      >
        {vm.connectors.map((connectorVm, i) => (
          <SymbolConnectorContainer
            key={connectorVm.cid}
            vm={connectorVm}
            isDisabled={isDisabled}
            placeholder={placeholder}
            actions={
              i === 0 ? (
                <SymbolConnectorAction
                  name="add"
                  label="Add another"
                  isDisabled={isDisabled}
                  onPress={vm.addAndFocus}
                  testId={testId && `${testId}-${i}-add-button`}
                />
              ) : (
                <SymbolConnectorAction
                  name="close"
                  label="Remove this"
                  isDisabled={isDisabled}
                  onPress={() => vm.remove(connectorVm)}
                  testId={testId && `${testId}-${i}-remove-button`}
                />
              )
            }
            testId={testId && `${testId}-${i}`}
          />
        ))}
      </SymbolConnectorList>
    )
  },
)
